import React from "react";

import { connect } from "../i18n/connect";
import { otpCodeFormFields } from "../lib/auth/otpCodeFormFields";
import {
  clearValidationError,
  otpRequestRoutine,
  verifyOtpRoutine
} from "../redux/modules/auth/register";
import {
  getOtpLastSentAt,
  getOtpRequestLoading,
  getOtpVerifyLoading,
  getRegisterValidationErrors
} from "../redux/modules/auth/register/selector";
import withFormBuilder from "./withFormBuilder";
import withUserData from "./withUserData";

export default function withLoginOtpPage(WrappedComponent) {
  const mapStateToProps = state => ({
    verifyLoading: getOtpVerifyLoading(state),
    otpRequestLoading: getOtpRequestLoading(state),
    otpLastSentAt: getOtpLastSentAt(state),
    validationErrors: getRegisterValidationErrors(state)
  });

  const mapDispatchToProps = {
    verifyOtp: verifyOtpRoutine.trigger,
    otpRequest: otpRequestRoutine.trigger,
    clearValidationError
  };

  @connect(mapStateToProps, mapDispatchToProps)
  @withFormBuilder(otpCodeFormFields)
  @withUserData
  class WithLoginOtpPage extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithLoginOtpPage;
}
